import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

const MenuThemes = ({idAsig}) => {
    const {temas} = useSelector(state => state.temas)
    return (
        <nav className='page__menu menu'>
            <ul className="menu__list r-list">
                {
                    temas.map(tema => (
                        <NavLink to={`/asignatura/${idAsig}/${tema.id}`} key={tema.id}>{tema.name}</NavLink>
                    ))
                }
            </ul>
        </nav>
    )
}

export default MenuThemes
